import React, { useEffect, useState } from "react";
import useWindowDimensions from "../../functions/getScreen";
import bgInfo from "../../assets/images/bg-menu-info.png";
import arrow from "../../assets/images/icon/arrow-right.svg";
import SecondaryButtonSmall from "../../components/button/SecondaryButtonSmall";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

export default function TopLuckyDraw(props) {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const mt = (32 * width) / 375

    const today = dayjs(new Date).format('DD/MM/YYYY')
    console.log(props)

    useEffect(() => {
    }, []);

    return (
        <>
            <div className="relative">
                <img className="w-full mt-[-10px]" src={bgInfo} alt="" />
                <span
                    style={{
                        fontSize: (20 * width) / 375,
                        // bottom: props.ishaveReward ? (50 * width) / 375 : (80 * width) / 375,
                        top: (20 * width) / 375,
                        left: (30 * width) / 375,
                    }}
                    className="text-white absolute"
                >
                    <p className="text-[16px] font-semibold leading-[11px] w-[170px]">
                        {props.campaignName}
                    </p>
                    {props.ishaveReward &&
                        <SecondaryButtonSmall onClick={() => navigate('/lucky-draw-result')} className="icon-next" style={{ position: 'absolute', top: mt }}>
                            <p>ยืนยันตัวตน</p>
                            <img className="w-[5px]" src={arrow} alt="" />
                        </SecondaryButtonSmall>
                    }
                </span>

                <span
                    style={{
                        fontSize: (20 * width) / 375,
                        top: (20 * width) / 375,
                        right: (30 * width) / 375,
                    }}
                    className="text-white absolute"
                >
                    <p className="text-[16px] leading-[11px]">
                    จำนวนสิทธิ์สะสม
                    </p>
                    <p className="text-[48px]" style={{ marginBottom: mt }}>{props.campaignUsed} สิทธิ์</p>
                </span>
            </div>
        </>


    );
}